// 用promise在iphone中会出现回掉函数不响应的问题，改写
import {
  // initAllList,
  initAllList2,
  // initEliteList,
  initEliteList2,
  // getMoreAllList,
  getMoreAllList2,
  // pubPraise,
  pubPraise2,
  // delPraise,
  delPraise2,
  // getPraiseInfoList,
  getPraiseInfoList2,
  // getPostInfo,
  getPostInfo2,
  getUserHeadUrl,
  getUserHomeUrl
} from '@/api/actions'
import {toast, statistics} from '@/utils/index'
var DEFAULT_TIMER = 30000
var FIRST_TIMER = 3000

// 两个列表的状态，数据，以及获取数据的行为
export default {
  state: {
    // 全部 全部直播的分页信息根据list中首尾的评论id去获取
    all: {
      id: 'all',
      list: [],
      nomore: false,
      loading: true,

      // iphone会出现滚动到底部但是不触发底部加载更多的事件
      // 这里做的处理是给放宽触发事件的条件，这样会出现多次请求的情况
      // 这里给一个状态，确保请求只发送一次，即当第一次有请求时，不会继续发送请求
      bottomRequesting: false
    },
    // 精华
    elite: {
      id: 'elite',
      list: [],
      nomore: false,
      loading: true,
      inited: false,

      bottomRequesting: false,

      // 分页信息
      pageInfo: {
        PageCount: 0,
        PageIndex: 1,
        PageSize: 30,
        TotalCount: 0
      }
    },
    // 是否有新信息
    hasNew: false,

    // 赞信息
    praiseIdList: [],
    praiseCountList: {},

    // 帖子信息，插入的帖子信息会放到这里，然后替换原来的评论信息
    postInfo: {},
    activeId: 'all',

    // 定时器
    timeout: null,
    interval: null
  },

  actions: {
    // 初始化全部直播的列表
    // callback是为了改变下拉刷新spinner的状态
    getAllListInfo ({state, rootState, dispatch}, callback) {
      dispatch('loading', 'all')
      initAllList2({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          orderBy: 3,
          pageSize: 15
        },
        success: function (response) {
          dispatch('loaded', 'all')
          // 将获取到的信息绑定到数据模型上
          state.all.list = response.CommentInfoList
          dispatch('getPraiseList', response.CommentInfoList)
          callback && callback()
          // 首次加载如果是显示精华则不初始化timer
          if (state.activeId === 'all') {
            dispatch('initTimer')
          }
        },
        error: function (error) {
          dispatch('loaded', 'all')
          toast('网络错误')
          callback && callback()
          throw new Error(error)
        }
      })
    },

    loading ({state}, type) {
      state[type].loading = true
    },

    loaded ({state}, type) {
      state[type].loading = false
    },

    // 刷新
    reload ({state, dispatch}, callback) {
      dispatch('clearTimer')
      state.hasNew = false
      state.all.nomore = false
      state.elite.nomore = false
      if (state.activeId === 'all') {
        dispatch('getAllListInfo', callback)
      } else {
        dispatch('initEliteList', callback)
      }
    },

    // 获取赞信息
    getPraiseList ({state, dispatch}, commentList) {
      let idList = []
      if (commentList.length === 0) {
        return
      }
      commentList.forEach(item => {
        idList.push(item.CommentID)
      })
      getPraiseInfoList2({
        params: {
          InfoIDs: idList.join('|')
        },
        success: function (response) {
          dispatch('handlePraiseCountAndShow', response.PraiseCounts)
        },
        error: function (error) {
          toast('获取赞信息失败')
          throw new Error(error)
        }
      })
    },

    handlePraiseCountAndShow ({state}, list) {
      if (!list || list.length === 0) {
        return
      }
      var obj = {}
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        var id = item.CommentID || item.InfoID
        obj[id] = {
          count: item.Count,
          isShow: item.IsShow
        }
      }
      state.praiseCountList = Object.assign({}, state.praiseCountList, obj)
    },

    // 初始化精华列表
    initEliteList ({state, rootState, dispatch}, callback) {
      dispatch('loading', 'elite')
      initEliteList2({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          pageSize: 10,
          orderBy: 3
        },
        success: function (response) {
          dispatch('loaded', 'elite')
          state.elite.list = response.CommentInfoList
          dispatch('getPraiseList', response.CommentInfoList)
          dispatch('changeElitePageInfo', response.PageInfo)
          callback && callback()
        },
        error: function (error) {
          dispatch('loaded', 'elite')
          toast('网络错误')
          callback && callback()
          throw new Error(error)
        }
      })
    },

    // 获取更多精华
    getEliteMoreInfo ({state, rootState, dispatch}) {
      if (!rootState.loadmore) {
        return
      }
      if (state.elite.nomore) {
        return
      }
      if (state.elite.bottomRequesting) return
      dispatch('loading', 'elite')
      state.elite.bottomRequesting = true
      state.elite.pageInfo.PageIndex += 1
      initEliteList2({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          orderBy: 3,
          pageSize: 10,
          pageIndex: state.elite.pageInfo.PageIndex
        },
        success: function (response) {
          if (response.CommentInfoList.length > 0) {
            response.CommentInfoList.forEach(item => {
              state.elite.list.push(item)
            })
            dispatch('getPraiseList', response.CommentInfoList)
          }
          dispatch('changeElitePageInfo', response.PageInfo)
          state.elite.bottomRequesting = false
          dispatch('loaded', 'elite')
        },
        error: function (error) {
          toast('网络错误')
          state.elite.bottomRequesting = false
          dispatch('loaded', 'elite')
          throw new Error(error)
        }
      })
    },

    // 更新精华评论的分页信息
    changeElitePageInfo ({state}, pageInfo) {
      state.elite.pageInfo = pageInfo
      if (state.elite.pageInfo.PageIndex >= state.elite.pageInfo.PageCount) {
        state.elite.nomore = true
      }
    },

    // 改变显示的列表
    changActiveId ({state, dispatch, rootState}, id) {
      state.activeId = id
      if (id === state.elite.id && !state.elite.inited) {
        dispatch('initEliteList')
        state.elite.inited = true
      }
      let postId = rootState.header.pageInfo.PostId
      if (id === state.all.id) {
        statistics('All', postId)
      } else if (id === state.elite.id) {
        state.hasNew = false
        statistics('SpecOnly', postId)
      }
    },

    // 初始化定时器
    initTimer ({state, dispatch}) {
      // 初始化timeout
      dispatch('firstMoreAllRequest')

      // 初始化interval（页面请求轮询）
      dispatch('setTimerGetter', function () {
        dispatch('getAllMoreInfo')
      })
    },

    // 首次请求直播列表
    firstMoreAllRequest ({state, dispatch}) {
      // 页面加载之后，首次轮询在FIRST_TIMER秒之后
      state.timeout = window.setTimeout(function () {
        dispatch('getAllMoreInfo')
      }, FIRST_TIMER)
    },

    // 列表切换之间，处理定时器的逻辑
    handleTimer ({state, dispatch}, {oldId, newId}) {
      // 列表不改变
      if (oldId === newId) {
        return
      }

      // 切换到精华列表
      if (newId === state.elite.id) {
        dispatch('clearTimer')
      }

      // 切换到全部直播列表
      if (newId === state.all.id) {
        dispatch('initTimer')
      }
    },

    // 放置interval，轮询
    setTimerGetter ({state, dispatch}, fn) {
      state.interval = setInterval(function () {
        fn && fn()
      }, DEFAULT_TIMER)
    },

    // 轮询获取全部直播的请求
    getAllMoreInfo ({state, rootState, dispatch}) {
      getMoreAllList2({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          // 全部直播数据模型列表的首条评论
          minCommentId: state.all.list[0] ? state.all.list[0].CommentID : 0
        },
        success: function (response) {
          if (response.length === 0) {
            return
          } else {
            // 返回数据按照CommentID升序排列
            if (document.body.scrollTop > window.innerHeight) {
              state.hasNew = true
              return
            }
            dispatch('unshiftAll', response)
            dispatch('getPraiseList', response)
          }
        },
        error: function (error) {
          toast('网络错误')
          throw new Error(error)
        }
      })
    },

    // 清除定时器
    clearTimer ({state}) {
      clearInterval(state.interval)
      clearTimeout(state.timeout)
    },

    // 获取更多直播的信息（历史信息）
    getMoreAllBottomList ({state, rootState, dispatch, commit}) {
      if (!rootState.loadmore) {
        return
      }
      if (state.all.bottomRequesting) {
        return
      }
      var length = state.all.list.length
      state.all.bottomRequesting = true
      // window.alert('request')
      dispatch('loading', 'all')
      getMoreAllList2({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          maxCommentId: state.all.list[length - 1].CommentID,
          topNum: 10
        },
        success: function (response) {
          if (response.length === 0) {
            commit('ALL_NOMORED')
            toast('到底了，别扯了')
          } else {
            // window.alert('beforerender')
            dispatch('pushAll', response)
            dispatch('getPraiseList', response)
          }
          state.all.bottomRequesting = false
          dispatch('loaded', 'all')
        },
        error: function (error) {
          toast('网络错误')
          state.all.bottomRequesting = false
          dispatch('loaded', 'all')
          throw new Error(error)
        }
      })
    },

    // 请新信息插入全部直播的队列首
    unshiftAll ({state}, list) {
      if (!Array.isArray(list) || list.length === 0) {
        return
      }
      // 每隔一秒钟插入一条信息，营造出直播的实时感。。233
      for (let i = 0; i < list.length; i++) {
        setTimeout(function unshift () {
          state.all.list.unshift(list[i])
          state.all.list.pop()
        }, i * 1000)
      }
    },

    // 插入帖子获取帖子信息
    // @data 是原评论的信息
    getPostInfo ({state}, {id, data}) {
      getPostInfo2({
        params: {
          id: id
        },
        success: function (response) {
          if (response.State === 1) {
            let info = response.Result
            // 更新原评论的信息并放入到postInfo中
            let o = Object.assign({}, data, {
              PostID: info.Id,
              PostTitle: info.Title,
              CommentContent: info.Content,
              UserName: info.TitularName,
              UserID: info.TitularId,
              UserHeadUrl: getUserHeadUrl(info.TitularId),
              UserHomeUrl: getUserHomeUrl(info.TitularName),
              ImagePath: info.ImagesField,
              IsPost: true
            })
            state.postInfo = Object.assign({}, state.postInfo, {
              [id]: o
            })
          } else {
            let info = {
              PostID: id,
              CommentContent: '[帖子]不存在',
              IsPost: true
            }
            state.postInfo = Object.assign({}, state.postInfo, {
              [id]: info
            })
          }
        },
        error: function (error) {
          toast('网络错误')
          let info = {
            PostID: id,
            CommentContent: '[帖子]加载失败',
            IsPost: true
          }
          state.postInfo = Object.assign({}, state.postInfo, {
            [id]: info
          })
          throw new Error(error)
        }
      })
    },

    // 队列首插入信息）
    unshiftAllComment ({state}, item) {
      state.all.list.unshift(item)
    },

    // 队列末尾插入信息
    pushAll ({state}, list) {
      state.all.list = state.all.list.concat(list)
    },

    // 处理点赞的情况
    handlePraise ({state, dispatch}, info) {
      var item = state.praiseCountList[info.CommentID]
      if (item) {
        if (item.isShow) {
          dispatch('postPraise', info)
        } else {
          dispatch('delPraise', info)
        }
      } else {
        dispatch('postPraise', info)
      }
    },

    // 取消赞
    delPraise ({state}, info) {
      delPraise2({
        params: {
          InfoID: info.CommentID
        },
        success: function (response) {
          if (response.Status === 100) {
            state.praiseCountList[info.CommentID].isShow = true
            state.praiseCountList[info.CommentID].count -= 1
          } else {
            toast(response.Message)
          }
        },
        error: function (error) {
          toast('网络错误')
          throw new Error(error)
        }
      })
    },

    // 点赞
    postPraise ({state, rootState}, info) {
      pubPraise2({
        params: {
          InfoID: info.CommentID,
          InfoMemo: info.CommentContent || `comment${info.CommentID}`,
          TopicUserName: info.UserName
        },
        success: function (response) {
          if (response.Status === 100) {
            if (state.praiseCountList[info.CommentID]) {
              state.praiseCountList[info.CommentID].count += 1
              state.praiseCountList[info.CommentID].isShow = false
            } else {
              state.praiseCountList = Object.assign({}, state.praiseCountList, {
                [info.CommentID]: {
                  isShow: false,
                  count: 1
                }
              })
            }
          } else {
            toast(response.Message)
          }
        },
        error: function (error) {
          toast('网络错误')
          throw new Error(error)
        }
      })
    }
  },

  mutations: {
    ALL_NOMORED (state) {
      state.all.nomore = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/list.js